<template>
  <div class="h-full">
    <!-- <div class=""> -->
    <div class="table component" v-if="showTable">
      <!-- Table -->
      <div class="wrapper">
        <table>
          <thead v-if="tableOptions.showHeader">
            <tr>
              <th
                :class="[getClassNames(a.classNames), a.noSort ? 'no-sort' : '']"
                v-for="a in localAttributes"
                :key="a.name"
                @click="canSort(a)"
              >
                <span :class="'s' + a.sorted">{{ a.label }}</span>
              </th>
              <th class="action" v-if="hasActions">
                <span class="head-action" @click="headAction()" v-if="hasHeadAction">
                  {{ tableOptions.headAction }}
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in pagedItems" :key="item.id" @dblclick="editItem(item)">
              <td :class="getClassNames(a.classNames)" v-for="a in localAttributes" :key="a.name">
                <span v-if="a.type === 'badge'">
                  <span class="badge" :class="a.config[getProperty(item, a.name)].color">
                    {{ a.config[getProperty(item, a.name)].text }}
                  </span>
                </span>
                <span
                  v-if="
                    a.type === 'tick' &&
                      getProperty(item, a.name) != tableOptions.emptyText &&
                      getProperty(item, a.name)
                  "
                >
                  <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M1 7L5 11L15 1"
                      stroke="#10B981"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
                <span v-if="a.type === 'image'">
                  <payment-icons :type="getProperty(item, a.name)"></payment-icons>
                </span>
                <span v-if="a.type === 'currency'"> ${{ getProperty(item, a.name) }}</span>
                <span v-if="a.type === 'text' || !a.type"> {{ getProperty(item, a.name) }}</span>
                <span v-if="a.type === 'date'"> {{ getProperty(item, a.name) | date('dd-MM-yyyy') }}</span>
              </td>
              <td class="action" v-if="hasActions">
                <!-- Check -->
                <div class="check" v-if="tableOptions.check">
                  <input
                    type="checkbox"
                    v-model="item[tableOptions.checkProperty]"
                    :checked="item[tableOptions.checkProperty]"
                    :name="item.id + '-checked'"
                    :id="item.id + '-checked'"
                    @change="checkItem(item)"
                    :key="item.id + item.table_timestamps"
                    :disabled="actionDisbled"
                  />
                </div>

                <!-- EDIT -->
                <a class="edit" @click="editItem(item)" v-if="tableOptions.edit">
                  <span v-if="iconActions"><i class="icn icn-pencil-alt sm"></i></span>
                  <span class="action-label" v-if="!iconActions">{{ tableOptions.editLabel }}</span>
                </a>

                <!-- DELETE -->
                <a class="delete" @click="deleteItem(item)" v-if="tableOptions.delete">
                  <span v-if="iconActions"><i class="icn icn-trash sm"></i></span>
                  <span class="action-label" v-if="!iconActions">{{ tableOptions.deleteLabel }}</span>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Paginator -->
      <div class="paginator" v-if="showPaginator">
        <div class="size" v-if="tableOptions.pages && tableOptions.pages.length > 1">
          <select v-model="itemsPerPage" @change="pageItems()">
            <option :value="page" v-for="page in tableOptions.pages" :key="page">{{ page }}</option>
          </select>
        </div>
        <div class="count" v-if="items">
          {{ start + 1 }}-{{ end > items.length ? items.length : end }} of {{ items.length }}
        </div>
        <div class="nav">
          <div class="icon prev" @click="prevPage()"><i class="icn icn-chevron-left sm"></i></div>
          <div class="icon" @click="nextPage()"><i class="icn icn-chevron-right sm"></i></div>
        </div>
      </div>
    </div>

    <!-- Empty -->
    <div class="empty" v-if="showEmpty">
      <div class="empty-content">
        <img v-if="!tableOptions.discreet" src="@/assets/img/empty.png" alt="empty" />
        <div class="title" v-if="!filtered">No records to display</div>
        <div class="description" v-if="!filtered">Looks like this table is empty.</div>
        <div class="title" v-if="filtered">No result found for this search</div>
        <div class="description" v-if="filtered">Sorry we couldn't find any results matching your search.</div>
      </div>
    </div>
  </div>
</template>

<script>
import PaymentIcons from './PaymentIcons.vue';
/**
 * Sends "edit", "delete", "check" and "head" outputs when an item is selected.
 */
export default {
  components: { PaymentIcons },
  name: 'Table',

  data() {
    return {
      localItems: [],
      localAttributes: [],
      filtered: false,
      sortBy: null,
      pagedItems: [],
      itemsPerPage: 50,
      numberOfPages: null,
      currentPage: 0,
      start: null,
      end: null,
      tableOptions: {
        edit: false,
        delete: false,
        check: false,
        editLabel: 'Edit',
        deleteLabel: 'Delete',
        checkProperty: 'checked',
        pages: [25, 50, 100, 200],
        emptyText: '-',
        headAction: null,
        discreet: false,
        showHeader: true,
        blockPageOnUpdate: false,
      },
    };
  },
  props: {
    items: {
      type: Array,
      default: () => [],
      required: true,
    },
    attributes: {
      default: () => [],
      required: true,
    },
    options: {
      type: Object,
      default: () => ({}),
    },
    actionDisbled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasActions() {
      return (
        this.tableOptions.edit === true ||
        this.tableOptions.delete === true ||
        this.tableOptions.check === true ||
        this.hasHeadAction
      );
    },
    iconActions() {
      return this.tableOptions.useIcons;
    },
    hasHeadAction() {
      return this.tableOptions.headAction && this.tableOptions.headAction.length > 0;
    },
    showPaginator() {
      if (!this.tableOptions.pages) return false;
      const min = Math.min(...this.tableOptions.pages);
      return this.items && this.items.length > min;
    },
    showTable() {
      return (this.pagedItems && this.pagedItems.length > 0) || this.hasHeadAction;
    },
    showEmpty() {
      return !this.localItems || this.localItems.length === 0;
    },
  },
  watch: {
    items() {
      this.init();
    },
  },

  mounted() {
    // We cannot put the default values in the props
    // as they will by deleted when an object is provided
    Object.assign(this.tableOptions, this.options, this.tableOptions);
    this.init();
  },

  methods: {
    getProperty(item, properyPath) {
      if (!properyPath.includes('.')) {
        if (item[properyPath] !== null) return item[properyPath];
        else return this.tableOptions.emptyText;
      }

      const props = properyPath.split('.');

      let data;
      let acc = item;
      for (let i = 0; i < props.length; i++) {
        const prop = props[i];
        if (!acc[prop]) {
          return this.tableOptions.emptyText;
        }
        if (i === props.length - 1) {
          data = acc[prop];
        } else {
          acc = acc[prop];
        }
      }

      return data;
    },

    editItem(item) {
      this.$emit('edit', item);
    },
    deleteItem(item) {
      this.$emit('delete', item);
    },
    checkItem(item) {
      this.$emit('check', item);
    },
    headAction() {
      this.$emit('head');
    },

    init() {
      if (this.tableOptions.blockPageOnUpdate != true) {
        this.currentPage = 0;
      }
      this.localItems = this.items.map(e => ({
        ...e,
        table_timestamps: Date.now(),
      }));
      this.localAttributes = this.attributes;
      this.itemsPerPage =
        this.tableOptions.pages && this.tableOptions.pages.length > 1
          ? this.tableOptions.pages[1]
          : this.tableOptions.pages[0];
      if (this.localItems) {
        this.filtered = this.localItems.filter(i => i.hide).length > 0;
        this.pageItems();
        this.sortItems();
      }
    },

    sortItems() {
      if (this.sortBy) {
        this.localAttributes = this.localAttributes.map(a => {
          return {
            ...a,
            sorted: a.name === this.sortBy.name ? (!this.sortBy.sorted || this.sortBy.sorted === 2 ? 1 : 2) : 0,
          };
        });
        const isNumber =
          this.localItems.filter(i => !isNaN(this.getProperty(i, this.sortBy.name))).length === this.localItems.length;
        const reverse = this.sortBy.sorted === 1 ? -1 : 1;
        this.localItems = [
          ...this.localItems.sort((a, b) => {
            const aAttr = isNumber
              ? parseFloat(this.getProperty(a, this.sortBy.name))
              : this.getProperty(a, this.sortBy.name)
              ? this.getProperty(a, this.sortBy.name).toLowerCase()
              : '';
            const bAttr = isNumber
              ? parseFloat(this.getProperty(b, this.sortBy.name))
              : this.getProperty(b, this.sortBy.name)
              ? this.getProperty(b, this.sortBy.name).toLowerCase()
              : '';
            return aAttr > bAttr ? 1 * reverse : bAttr > aAttr ? -1 * reverse : 0;
          }),
        ];

        if (this.tableOptions.blockPageOnUpdate != true) {
          this.currentPage = 0;
        }
        this.pageItems();
      }
    },

    pageItems() {
      if (this.localItems) {
        if (this.tableOptions.blockPageOnUpdate != true) {
          this.currentPage = 0;
        }
        this.start = this.currentPage * this.itemsPerPage;
        this.end = (this.currentPage + 1) * this.itemsPerPage;
        this.numberOfPages = Math.ceil(this.localItems.length / this.itemsPerPage) - 1;
        this.localItems = this.localItems.filter(o => !o.hide);
        this.pagedItems = this.localItems.slice(this.start, this.end);
      }
    },

    nextPage() {
      if (this.currentPage < this.numberOfPages) {
        this.currentPage++;
        this.start = this.currentPage * this.itemsPerPage;
        this.end = (this.currentPage + 1) * this.itemsPerPage;
        this.pagedItems = this.localItems.slice(this.start, this.end);
      }
    },

    prevPage() {
      if (this.currentPage > 0) {
        this.currentPage--;
        this.start = this.currentPage * this.itemsPerPage;
        this.end = (this.currentPage + 1) * this.itemsPerPage;
        this.pagedItems = this.localItems.slice(this.start, this.end);
      }
    },
    getClassNames(input) {
      return input ? input : '';
    },
    canSort(attribute) {
      if (attribute.noSort) return;
      this.sortBy = attribute;
      this.sortItems();
    },
  },
};
</script>
